import React from 'react';
import { 
  BiCode, 
  BiCodeCurly, 
  BiFileBlank, 
  BiWindow, 
  BiLayout, 
  BiData, 
  BiGlobe,
  BiMobile,
  BiDevices
} from 'react-icons/bi';

const Services = () => {
  const servicesList = [
    {
      icon: <BiMobile />,
      title: "Flutter Mobile App Development",
      description: "Building cross-platform mobile applications with Flutter and Dart for iOS and Android with hardware and backend integrations.",
      delay: "100"
    },
    {
      icon: <BiDevices />,
      title: "Responsive UI/UX Design",
      description: "Crafting modern, accessible, and intuitive user interfaces optimized for mobile phones, tablets, and desktop displays.",
      delay: "200"
    },
    {
      icon: <BiData />,
      title: "Backend & Database Architecture",
      description: "Designing and integrating robust RESTful backends and databases with Django REST Framework, PostgreSQL, Supabase, and Firebase.",
      delay: "300"
    },
    {
      icon: <BiWindow />,
      title: "Front-end Web Development",
      description: "Designing responsive and interactive web interfaces with modern React, JavaScript, HTML5, and CSS3.",
      delay: "400"
    },
    {
      icon: <BiGlobe />,
      title: "Web Applications",
      description: "Building modern, responsive, and performant web applications using clean modular architectures.",
      delay: "500"
    },
    {
      icon: <BiLayout />,
      title: "EJS & Full-Stack Templating",
      description: "Developing dynamic server-rendered pages and interactive web templates.",
      delay: "600"
    },
    {
      icon: <BiCodeCurly />,
      title: "Java Development",
      description: "Building robust, scalable, and secure object-oriented applications with Java and desktop UI frameworks.",
      delay: "700"
    },
    {
      icon: <BiFileBlank />,
      title: "JavaFX Applications",
      description: "Creating rich client desktop applications with modern JavaFX components and clean architectures.",
      delay: "800"
    },
    {
      icon: <BiCode />,
      title: "C / C++ Development",
      description: "Developing high-performance applications, low-level data structures, and system software using C and C++.",
      delay: "900"
    }
  ];

  return (
    <section id="services" className="services section">
      <div className="container section-title" data-aos="fade-up">
        <h2>Services</h2>
        <p>I offer end-to-end software engineering and development services—specializing in production Flutter mobile apps, hardware BLE integrations, scalable backend services, and high-performance system programming in C/C++ and Java.</p>
      </div>

      <div className="container">
        <div className="row gy-4">
          {servicesList.map((service, index) => (
            <div 
              key={index} 
              className="col-lg-4 col-md-6 d-flex align-items-stretch" 
              data-aos="fade-up" 
              data-aos-delay={service.delay}
            >
              <div className="service-item d-flex w-100">
                <div className="icon flex-shrink-0">{service.icon}</div>
                <div>
                  <h4 className="title">{service.title}</h4>
                  <p className="description">{service.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
